import { render } from "./PlanOverview.vue?vue&type=template&id=84b417c0&scoped=true"
import script from "./PlanOverview.vue?vue&type=script&lang=js"
export * from "./PlanOverview.vue?vue&type=script&lang=js"

import "./PlanOverview.vue?vue&type=style&index=0&id=84b417c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84b417c0"]])

export default __exports__